import React from 'react'
import RegistrierenDialog from "./RegistrierenDialog";
import ZugangVergessenDialog from "./ZugangVergessenDialog";
import PropTypes from "prop-types";
import ErrorInfoComponent from "./general/ErrorInfoComponent";
import DHButtonDefault from "./general/DHButtonDefault";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import KeyIcon from '@mui/icons-material/Key';
import DHTextFieldSmall from "./general/DHTextFieldSmall";
import DHPasswordFieldSmall from "./general/DHPasswordFieldSmall";

const initialState = {
    name: "",
    password: "",
    showRegistrieren: false,
    showZugangVergessen: false
};

class Login extends React.Component {

    constructor(props) {
        super(props);

        this.state = initialState;

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handelKeyDown = this.handelKeyDown.bind(this);
        this.callBackLoginFehlerhaft = this.callBackLoginFehlerhaft.bind(this);
        this.showError = this.showError.bind(this);
    }

    showError(message) {
        this.setState({errorMessage: message});
    }

    handelKeyDown(e) {
        if (e.keyCode === 13) {
            // enter
            this.doLogin();
        }
    }

    handleNameChange(value) {
        this.setState({name: value});
    }

    handlePasswordChange(value) {
        this.setState({password: value});
    }

    doLogin() {
        this.showError(undefined);
        if (this.state.name.length === 0 || this.state.password.length === 0) {
            return;
        }
        this.props.login(this.state.name, this.state.password, () => "", this.callBackLoginFehlerhaft);
    }

    callBackLoginFehlerhaft(message) {
        this.showError(message);
    }

    render() {
        return <div>
            <div>
                <ErrorInfoComponent errorMessage={this.state.errorMessage} infoMessage={this.state.infoMessage} warnMessage={this.state.warnMessage}
                                    onClearInfoMessage={() => this.setState({infoMessage: undefined})}
                                    onClearErrorMessage={() => this.setState({errorMessage: undefined})}
                                    onClearWarnMessage={() => this.setState({warnMessage: undefined})}/>
                <div style={{display: "flex", width: "100%", marginTop: 10}}>
                    <DHTextFieldSmall value={this.state.name} onChange={(text) => this.handleNameChange(text)} label="Benutzername"
                                      id={"id-username"} onKeyDown={(e) => this.handelKeyDown(e)} width={200} showPlaceholder={true}/>
                </div>
                <div style={{display: "flex", width: "100%", marginTop: 10}}>
                    <DHPasswordFieldSmall id="id-password" value={this.state.password}
                                          label={"Kennwort"}
                                          width={200}
                                          onChange={(text) => this.handlePasswordChange(text)}
                                          onKeyDown={(e) => this.handelKeyDown(e)}/>
                    <DHButtonDefault label="Anmelden" disabled={this.state.name.length === 0 || this.state.password.length === 0}
                                     onClick={() => this.doLogin()} style={{marginLeft: 5}}/>
                </div>
            </div>
            <div style={{display: "flex", marginTop: 5}}>
                <DHButtonDefault label="Registrieren"
                                 icon={<HowToRegIcon/>}
                                 onClick={() => this.setState({showRegistrieren: true})}
                                 style={{marginRight: 5, fontSize: 10}}/>
                <DHButtonDefault label="Zugang vergessen"
                                 icon={<KeyIcon/>}
                                 onClick={() => this.setState({showZugangVergessen: true})}
                                 style={{fontSize: 10}}/>
            </div>
            {this.state.showRegistrieren && <RegistrierenDialog onClose={() => this.setState({showRegistrieren: false})}/>}
            {this.state.showZugangVergessen && <ZugangVergessenDialog onClose={() => this.setState({showZugangVergessen: false})}/>}
        </div>
    }
}

Login.propTypes = {
    login: PropTypes.func.isRequired
};

export default Login;
